import { render, staticRenderFns } from "./ShareTW.vue?vue&type=template&id=73bf07c7&"
import script from "./ShareTW.vue?vue&type=script&lang=js&"
export * from "./ShareTW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports